import { Component } from '@angular/core';
// import { EmployeeBreakInServiceReportService } from './employeeBreakInServiceReport.service';
// import { NgTableComponent, NgTableFilteringDirective, NgTablePagingDirective, NgTableSortingDirective } from 'ng2-table/ng2-table';
// import { ExportToExcelService } from '../shared/export.service';

@Component({
    moduleId: module.id,
    templateUrl: 'onboardingPersonalInformation.html'

})
export class OnboardingPersonalInformationComponent { }



// WEBPACK FOOTER //
// ./src/app/OnBoardingPersonalInformation/onboardingPersonalInformation.component.ts